import { css } from 'twin.macro';
import dayjs from 'dayjs';
import { useState } from 'react';
import Linkify from 'react-linkify';

import { Form } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import { marginColor } from './Checkbox';
import { ElementStyled, elementClass } from './styles/ElementStyles';
import { getDateFromDateTime } from '@/_helpers';
import BlockInputFieldPreview from './BlockInputField/Preview';
import { getPreviewValueFromBlockInput } from '../PdfTemplatePreview/utils';
import styled from '@emotion/styled';
const DatePickerContainer = styled.div`
    width: 230px;

    .react-date-picker {
        width: 100%;
    }

    .react-date-picker__wrapper {
        width: 100%;
        min-width: unset;
        border-radius: 2px;
        padding: 5px;
        border: 1px solid #ced4da;
    }
`;
const DateComponent = ({ data, elementRef, isPreview, error, onChange }) => {
    const [dateValue, setDateValue] = useState(data.value ? new Date(dayjs(data.value)) : new Date());
    const handleDateChange = (value) => {
        setDateValue(new Date(value));
        if (onChange) onChange(new Date(value).toISOString());
    };

    return (
        <ElementStyled className={elementClass(data)}>
            <Form.Group controlId="formGridEmail">
                <Form.Label className="mr-4">
                    <h5 className="warpIt">
                        {data.fieldName}
                        <span css={marginColor}>{(data.hasOwnProperty('required') ? data.required : true) && '*'}</span>
                        :
                    </h5>
                </Form.Label>
                {data.instruction && (
                    <pre className="small text-muted warpIt preStyles">
                        <Linkify
                            componentDecorator={(decoratedHref, decoratedText, key) => (
                                <a target="blank" href={decoratedHref} key={key}>
                                    {decoratedText}
                                </a>
                            )}
                        >
                            {data.instruction}
                        </Linkify>
                    </pre>
                )}
                <div className="d-flex flex-row justify-content-between">
                    <DatePickerContainer>
                        <DatePicker
                            value={dateValue}
                            onChange={handleDateChange}
                            clearIcon={null}
                            format="MM/dd/yyyy"
                            disabled={isPreview}
                        />
                    </DatePickerContainer>

                    {data?.options?.enableBlockPreview &&
                        data?.options?.enableBlockInput &&
                        data?.data &&
                        data?.data?.length > 0 && (
                            <div>
                                <BlockInputFieldPreview
                                    componentErrorMessage={'Failed to preview blocks.'}
                                    data={{
                                        data: data?.data || [],
                                        value: JSON.stringify(
                                            getPreviewValueFromBlockInput({
                                                data: data?.data || [],
                                                value: getDateFromDateTime(dateValue),
                                                key: 'DatePicker',
                                            })
                                        ),
                                    }}
                                    isPreview={true}
                                />
                            </div>
                        )}
                </div>

                <Form.Control
                    type="text"
                    name={`${!isPreview ? `DatePicker-${data._id}` : 'DatePicker'}`}
                    className="date-picker"
                    ref={
                        elementRef &&
                        elementRef({
                            required: data.hasOwnProperty('required') ? data.required : true,
                        })
                    }
                    css={css`
                        position: absolute;
                        opacity: 0 !important;
                        width: 0 !important;
                    `}
                    disabled={isPreview}
                    // value={(getDateTime(dateValue) + getTimeZoneDiff()).slice(0, 10)}
                    value={dateValue.toISOString()}
                    readOnly
                />
                <Form.Text className="text-danger">
                    {error && error.type === 'required' && 'This field is required'}
                </Form.Text>
            </Form.Group>
        </ElementStyled>
    );
};

export default DateComponent;
